import { StudyNote, Category } from '../types';

export interface ExportData {
  version: number;
  notes: StudyNote[];
  categories: Category[];
}

export const exportNotesToFile = (notes: StudyNote[], categories: Category[]): void => {
  const exportData: ExportData = { version: 1, notes, categories };
  const dataStr = JSON.stringify(exportData, null, 2);
  const dataBlob = new Blob([dataStr], { type: 'application/json' });
  const url = URL.createObjectURL(dataBlob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `bible-study-notes-${new Date().toISOString().split('T')[0]}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

export const importNotesFromFile = (file: File): Promise<ExportData> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const content = e.target?.result as string;
        const parsed = JSON.parse(content);
        
        // Support new format { version, notes, categories } and legacy format (plain array)
        if (Array.isArray(parsed)) {
          resolve({ version: 1, notes: parsed as StudyNote[], categories: [] });
          return;
        }

        if (parsed && Array.isArray(parsed.notes)) {
          resolve({
            version: parsed.version ?? 1,
            notes: parsed.notes as StudyNote[],
            categories: Array.isArray(parsed.categories) ? parsed.categories as Category[] : []
          });
          return;
        }

        reject(new Error('Invalid file format'));
      } catch (error) {
        reject(new Error('Failed to parse file: ' + (error as Error).message));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Failed to read file'));
    };
    
    reader.readAsText(file);
  });
};
